<template>
  <div>
      <validation-provider v-slot="{ errors }" :rules='required && options.length > 0 ? "required" : "" ' :name="label">
              <v-autocomplete
                    ref="refSelect"
                    :class="[classExtra ]"
                    v-model="myValue"
                    :items="options"
                    item-value="name"
                    item-text="name"
                    :disabled="disabled"
                    :placeholder="placeholder"
                    :outlined="outlined"
                    :label="label"
                    :clearable="clearable"
                    :readonly="readonly"
                    :dense="dense"
                    no-data-text="Không có dữ liệu"
                    :error-messages="errors"
                    @change="$emit('onChangeData', {
                        data: myValue,
                        name: nameRef,
                        event: eventModel,
                        change: true,
                    })"
                    persistent-placeholder
                >
                  <template  v-slot:label>
                      {{ label }}<span v-if="required && options.length > 0" style="color: red;margin-left: 2px;">*</span>
                  </template>
                <template v-slot:item="{ active, item, attrs, on }">
                  <v-list-item v-on="on" v-bind="attrs">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ item.name }} <span v-if="item.curriculum_title">({{ item.curriculum_title }})</span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
      </validation-provider>
  </div>
</template>
<script>
import { COMMON_PROPS_SELECT } from '@/modules/teacher-support/constaint/select';

export default {
  name: 'BaseSelect',
  props: { ...COMMON_PROPS_SELECT },
  data() {
    return {
      myValue: '',
      status: { valid: true },
    };
  },
  created() {
    this.myValue = this.value;
  },
  watch: {
    myValue() {
      this.$emit('input', this.myValue);
      this.$emit('changeSelect');
    },
    value(valueData) {
      this.myValue = this.value;
      this.$emit('input', valueData);
    },
  },

};
</script>
